/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Router from "vue-router";
import Store from "./store/store";
Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: "",
      component: () => import("./layouts/main/Main.vue"),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: "/",
          name: "home",
          component: () => import("@/views/Home.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next({
                path: "login"
              });
            }
          },
          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },

              { title: "Bilgilendirme", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/page2",
          name: "page-2",
          component: () => import("./views/Page2.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          }
        },

        {
          path: "/satis/hizlisatis",
          name: "hizlisatis",
          component: () => import("@/views/satis/Satis.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Satış" },
              { title: "Hızlı Satış", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/akinsoftsipariscek",
          name: "AkinSoftSiparisCek",
          component: () => import("@/views/pazaryeri/AkinSoft.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "AkinSoft", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },

        {
          path: "/pazaryeri/akinsoftkategoricek",
          name: "akinsoftkategoricek",
          component: () => import("@/views/pazaryeri/AkinSoftKategori.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "AkinSoft Kategori", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },

        {
          path: "/pazaryeri/toplu",
          name: "toplu",
          component: () => import("@/views/pazaryeri/toplu.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Toplu", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }


        },
        {
          path: "/pazaryeri/siparis",
          name: "siparis",
          component: () => import("@/views/pazaryeri/siparis.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Sipariş", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }


        },
        {
          path: "/pazaryeri/trendyolsipariscek",
          name: "TrendyolSiparisCek",
          component: () => import("@/views/pazaryeri/Trendyol.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Trendyol", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/idefixsipariscek",
          name: "IdefixSiparisCek",
          component: () => import("@/views/pazaryeri/Idefix.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "İdefix", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/temusipariscek",
          name: "TemuSiparisCek",
          component: () => import("@/views/pazaryeri/Temu.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Temu", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/trendyolkategoricek",
          name: "trendyolkategoricek",
          component: () => import("@/views/pazaryeri/TrendyolKategori.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Trendyol Kategori", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
      {
          path: "/pazaryeri/lcwaikikisipariscek",
          name: "LcWaikikiSiparisCek",
          component: () => import("@/views/pazaryeri/LcWaikiki.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "LcWaikiki", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/beymensipariscek",
          name: "BeymenSiparisCek",
          component: () => import("@/views/pazaryeri/Beymen.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Beymen", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/boynersipariscek",
          name: "BoynerSiparisCek",
          component: () => import("@/views/pazaryeri/Boyner.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Boyner", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/sopyosipariscek",
          name: "SopyoSiparisCek",
          component: () => import("@/views/pazaryeri/Sopyo.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Sopyo", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/platin360sipariscek",
          name: "Platin360SiparisCek",
          component: () => import("@/views/pazaryeri/Platin360.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Platin360", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/platin360kategoricek",
          name: "platin360kategoricek",
          component: () => import("@/views/pazaryeri/Platin360Kategori.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Platin360 Kategori", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },

        {
          path: "/pazaryeri/opencartsipariscek",
          name: "OpencartSiparisCek",
          component: () => import("@/views/pazaryeri/Opencart.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Opencart", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/allesgosipariscek",
          name: "AllesgoSiparisCek",
          component: () => import("@/views/pazaryeri/Allesgo.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Allesgo", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/opencartkategoricek",
          name: "opencartkategoricek",
          component: () => import("@/views/pazaryeri/OpencartKategori.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Opencart Kategori", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/allesgokategoricek",
          name: "allesgokategoricek",
          component: () => import("@/views/pazaryeri/AllesgoKategori.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Allesgo Kategori", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },

        {
          path: "/pazaryeri/shopifykategoricek",
          name: "shopifykategoricek",
          component: () => import("@/views/pazaryeri/ShopifyKategori.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Shopify Kategori", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/ozonsipariscek",
          name: "OzonSiparisCek",
          component: () => import("@/views/pazaryeri/Ozon.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Ozon", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/ozonkategoricek",
          name: "Ozonkategoricek",
          component: () => import("@/views/pazaryeri/OzonKategori.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Ozon Kategori", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/platinmarketkategoricek",
          name: "platinmarketkategoricek",
          component: () => import("@/views/pazaryeri/PlatinMarketKategori.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Platin Market Kategori", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/gittigidiyorkategoricek",
          name: "gittigidiyorkategoricek",
          component: () => import("@/views/pazaryeri/GittigidiyorKategori.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Gittigidiyor Kategori", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/ciceksepetikategoricek",
          name: "ciceksepetikategoricek",
          component: () => import("@/views/pazaryeri/CiceksepetiKategori.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Çiçek Sepeti Kategori", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/azallkategoricek",
          name: "azallkategoricek",
          component: () => import("@/views/pazaryeri/AzallKategori.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Azall Kategori", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/etsykategoricek",
          name: "azallkategoricek",
          component: () => import("@/views/pazaryeri/EtsyKategori.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Azall Kategori", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/etsysipariscek",
          name: "etsysipariscek",
          component: () => import("@/views/pazaryeri/Etsy.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Etsy", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/ikaskategoricek",
          name: "ikaskategoricek",
          component: () => import("@/views/pazaryeri/IkasKategori.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Ikas Kategori", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/pttavmkategoricek",
          name: "pttavmkategoricek",
          component: () => import("@/views/pazaryeri/PttAvmKategori.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "PttAvm Kategori", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/woocommerceKategori",
          name: "woocommerceKategori",
          component: () => import("@/views/pazaryeri/WoocommerceKategori.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Woocommerce Kategori", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/tsoftkategoricek",
          name: "tsoftkategoricek",
          component: () => import("@/views/pazaryeri/TsoftKategori.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Tsoft Kategori", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/ticimaxkategoricek",
          name: "ticimaxkategoricek",
          component: () => import("@/views/pazaryeri/TicimaxKategori.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Ticimax Kategori", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/entegra",
          name: "entegra",
          component: () => import("@/views/pazaryeri/entegra.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Entegra", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/n11kategoricek",
          name: "n11kategoricek",
          component: () => import("@/views/pazaryeri/N11Kategori.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "N11 Kategori", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/Modanisakategoricek",
          name: "modanisakategoricek",
          component: () => import("@/views/pazaryeri/ModanisaKategori.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Modanisa Kategori", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/hepsiburadakategoricek",
          name: "hepsiburadakategoricek",
          component: () => import("@/views/pazaryeri/HepsiburadaKategori.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Hepsiburada Kategori", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/hticaretsipariscek",
          name: "hticaretsipariscek",
          component: () => import("@/views/pazaryeri/HTicaret.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "H-Ticaret Sipariş", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/ideasoftsipariscek",
          name: "ideasoftsipariscek",
          component: () => import("@/views/pazaryeri/Ideasoft.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "İdeasoft Sipariş", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/ideasoftkategoricek",
          name: "ideasoftkategoricek",
          component: () => import("@/views/pazaryeri/IdeasoftKategori.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "İdeasoft Kategori", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/pazaramasipariscek",
          name: "pazaramasipariscek",
          component: () => import("@/views/pazaryeri/Pazarama.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Pazarama Sipariş", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/pazaramakategoricek",
          name: "pazaramakategoricek",
          component: () => import("@/views/pazaryeri/PazaramaKategori.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Pazarama Kategori", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },

        {
          path: "/pazaryeri/ticimaxsipariscek",
          name: "ticimaxsipariscek",
          component: () => import("@/views/pazaryeri/Ticimax.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Ticimax Sipariş", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/platinmarketsipariscek",
          name: "platinmarketsipariscek",
          component: () => import("@/views/pazaryeri/PlatinMarket.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "PlatinMarket Sipariş", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/azall",
          name: "azallsipariscek",
          component: () => import("@/views/pazaryeri/Azall.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Çiçek Sepeti Sipariş", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/ciceksepetisipariscek",
          name: "ciceksepetisipariscek",
          component: () => import("@/views/pazaryeri/CicekSepeti.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Çiçek Sepeti Sipariş", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/pttavmsipariscek",
          name: "pttavmsipariscek",
          component: () => import("@/views/pazaryeri/PttAvm.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "PttAvm Sipariş", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/ikasspariscek",
          name: "ikassipariscek",
          component: () => import("@/views/pazaryeri/Ikas.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Ikas Sipariş Çek", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/woocommercesipariscek",
          name: "woocommercesipariscek",
          component: () => import("@/views/pazaryeri/Woocommerce.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Woocommerce Sipariş", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/gittigidiyorsipariscek",
          name: "gittigidiyorsipariscek",
          component: () => import("@/views/pazaryeri/GittiGidiyor.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Gittigidiyor Sipariş", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/n11sipariscek",
          name: "n11sipariscek",
          component: () => import("@/views/pazaryeri/N11.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "N11", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/modanisasipariscek",
          name: "modanisasipariscek",
          component: () => import("@/views/pazaryeri/Modanisa.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Modanisa", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/morhiposipariscek",
          name: "morhiposipariscek",
          component: () => import("@/views/pazaryeri/Morhipo.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Morhipo", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/hepsiburadasipariscek",
          name: "hepsiburadasipariscek",
          component: () => import("@/views/pazaryeri/Hepsiburada.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Hepsiburada", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/tsoftsipariscek",
          name: "tsoftsipariscek",
          component: () => import("@/views/pazaryeri/Tsoft.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "TSoft", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/shopifysipariscek",
          name: "shopifysipariscek",
          component: () => import("@/views/pazaryeri/Shopify.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Shopify", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/clasysipariscek",
          name: "clasysipariscek",
          component: () => import("@/views/pazaryeri/Clasy.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Clasyevi", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/genelsipariscek",
          name: "GenelSiparisCek",
          component: () => import("@/views/pazaryeri/Genel.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Pazaryer", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/excelilesipariscek",
          name: "ExcelSiparisCek",
          component: () => import("@/views/pazaryeri/ExcelSiparisCek.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "ExcelSiparisCek", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/excelileurunfiyatguncelle",
          name: "Excel Ürün Fiyat Güncelle",
          component: () => import("@/views/pazaryeri/ExcelUrunFiyatGuncelle.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Excel Ürün Fiyat Güncelle", active: true }
            ],
            requiresAuth: true,
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/genelkategoricek",
          name: "Genelkategoricek",
          component: () => import("@/views/pazaryeri/GenelKategori.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Pazaryer Kategori", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/paketleme/urunPaketleme",
          name: "UrunPaketleme",
          component: () => import("@/views/paketleme/UrunPaketleme.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Paketleme" },
              { title: "Urun Paketleme", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/paketleme/urunToplama",
          name: "UrunToplama",
          component: () => import("@/views/paketleme/UrunToplama.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Paketleme" },
              { title: "Urun Toplama", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/paketleme/kargoTesellum",
          name: "kargoTesellum",
          component: () => import("@/views/paketleme/kargoTesellum.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Paketleme" },
              { title: "Kargo Tesellum", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/paketleme/kargoGenel",
          name: "kargoGenel",
          component: () => import("@/views/paketleme/kargoGenel.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Paketleme" },
              { title: "Kargo Genel", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },

        {
          path: "/paketleme/kullaniciGorevlendirme",
          name: "kullaniciGorevlendirme",
          component: () => import("@/views/paketleme/KullaniciGorevlendirme.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Paketleme" },
              { title: "Kullanıcı Görevlendirme", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/paketleme/cekiListesi",
          name: "cekiListesi",
          component: () => import("@/views/paketleme/cekiListesi.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Paketleme" },
              { title: "Kullanıcı Görevlendirme", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/account/tickets",
          name: "tickets",
          component: () => import("@/views/account/Tickets.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Hesabım" },
              { title: "Talepler", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/paketleme/CekiDetay/:orderNumber/:orderDate",
          name: "cekiDetay",
          component: () => import("@/views/paketleme/CekiDetay.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Paketleme" },
              { title: "Kullanıcı Görevlendirme", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/paketleme/paketlemeislemi",
          name: "paketlemeislemi",
          component: () => import("@/views/paketleme/Paketlemeislemi.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Paketleme" },
              { title: "Paketleme İşlemi", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/paketleme/hizliSatis",
          name: "hizliSatis",
          component: () => import("@/views/paketleme/hizliSatis.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Hızlı Satış" },
              { title: "Hızlı Satış", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/paketleme/toptanSiparis",
          name: "toptansiparis",
          component: () => import("@/views/paketleme/toptanSiparis.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Toptan Sipariş" },
              { title: "Toptan Sipariş", active: true }
            ],
            requiresAuth: true,
            rule: "editor"
          }
        },
        {
          path: "/paketleme/hizliSatisDepo",
          name: "hizliSatisDepo",
          component: () => import("@/views/paketleme/hizliSatisDepo.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Depo Sayım" },
              { title: "Depo Sayım", active: true }
            ],
            requiresAuth: true,
            rule: "editor"
          }
        },
        {
          path: "/paketleme/lojistik-islemleri",
          name: "lojistikIslemleri",
          component: () => import("@/views/paketleme/LojistikIslemleri.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Paketleme" },
              { title: "Lojistik İşlemleri", active: true }
            ],
            requiresAuth: true,
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/satisTanimlar",
          name: "satistanimlar",
          component: () => import("@/views/pazaryeri/SatisTanimlar.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },
          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Depo Sayım " },
              { title: "Depo Sayım", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/paketleme/iadeislemi",
          name: "iadeislemi",
          component: () => import("@/views/paketleme/iadeIslemleri.vue"), //component: () => import('@/views/paketleme/IadeIslemi.vue'),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "İade" },
              { title: "İade İşlemi", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/paketleme/iadeekle",
          name: "iadeekle",
          component: () => import("@/views/paketleme/IadeEkle.vue"), //component: () => import('@/views/paketleme/IadeIslemi.vue'),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "İade" },
              { title: "İade İşlemi", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/paketleme/iadeyonetimi",
          name: "iadeyonetimi",
          component: () => import("@/views/paketleme/IadeYonetimi.vue"), //component: () => import('@/views/paketleme/IadeIslemi.vue'),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "İade" },
              { title: "İade İşlemi", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/iadekabul",
          name: "İade",
          component: () => import("@/views/pazaryeri/iade.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "İade İşlemi", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/finans",
          name: "finans",
          component: () => import("@/views/pazaryeri/finans.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Finans İşlemi", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/stoklistesi",
          name: "Stok Listesi",
          component: () => import("@/views/pazaryeri/stokListesi.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Stok Listesi", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/stoklistesiyeni",
          name: "Stok Listesi",
          component: () => import("@/views/pazaryeri/StokListesiYeni.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },
          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Stok Listesi", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/stok-listesi",
          name: "Stok Listesi",
          component: () => import("@/views/pazaryeri/StokListesiXml.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Stok Listesi", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },

        {
          path: "/pazaryeri/tedarikci-siparisleri",
          name: "TedarikciSiparisleri",
          component: () => import("@/views/pazaryeri/TedarikciSiparisleri.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Tedarikçi Siparişleri", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/stok-esleme",
          name: "Stok Esleme",
          component: () => import("@/views/pazaryeri/StokEsleme.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Stok Esleme", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/stok-esleme-manuel",
          name: "Stok Esleme Manuel",
          component: () => import("@/views/pazaryeri/StokEslemeManuel.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Stok Esleme Manuel", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/stok-kampanya",
          name: "Stok Kampanya",
          component: () => import("@/views/pazaryeri/StokKampanya.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Stok Kampanya", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/ticimax-sipariscek",
          name: "ticimax-sipariscek",
          component: () => import("@/views/pazaryeri/xmlTicimax.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Ticimax Sipariş Çek", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },

        {
          path: "/topluislemler/netsis_netsis",
          name: "NetsisFaturaAktarim",
          component: () => import("@/views/topluislem/NetsisFaturaAktarim.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Toplu İşlem" },
              { title: "Netsis Fatura Aktarim", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/topluislemler/sysmond-fatura-aktarim",
          name: "SysmondFaturaAktarim",
          component: () => import("@/views/topluislem/SysmondFaturaAktarim.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Toplu İşlem" },
              { title: "Sysmond Fatura Aktarim", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/topluislemler/tekrar-fatura-aktarim",
          name: "TekrarFaturaAktarim",
          component: () => import("@/views/topluislem/TekrarFaturaAktarim.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Toplu İşlem" },
              { title: "Sysmond Fatura Aktarim", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/topluislemler/fatura-gonderim",
          name: "FaturaGonderim",
          component: () => import("@/views/topluislem/FaturaGonderim.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Toplu İşlem" },
              { title: "Fatura Gönderim", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/topluislemler/sms-gonderim",
          name: "TopluSmsGonderim",
          component: () => import("@/views/topluislem/TopluSmsGonderim.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Toplu İşlem" },
              { title: "Sms Gönderim", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/finans/cari_yonetimi",
          name: "CariYonetimi",
          component: () => import("@/views/finans/CariYonetimi.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Finans" },
              { title: "Cari Yönetimi", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/finans/stok_yonetimi",
          name: "StokYonetimi",
          component: () => import("@/views/finans/StokYonetimi.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Finans" },
              { title: "Stok Yönetimi", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/mp-stokyonetimi/stok-listesi",
          name: "MpStokListesi",
          component: () => import("@/views/mp-stokyonetimi/MpStokListesi.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Stok Yönetimi" },
              { title: "Stok Listesi", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/mp-stokyonetimi/stok-recetesi",
          name: "MpStokRecetesi",
          component: () => import("@/views/mp-stokyonetimi/MpStokRecetesi.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Stok Yönetimi" },
              { title: "Stok Reçetesi", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/mp-stokyonetimi/uretim-islemi",
          name: "MpUretimIslemi",
          component: () => import("@/views/mp-stokyonetimi/MpUretimIslemi.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Stok Yönetimi" },
              { title: "Üretim İşlemi", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/mp-stokyonetimi/sevkiyat-islemi",
          name: "MpSevkiyat",
          component: () => import("@/views/mp-stokyonetimi/MpSevkiyat.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Stok Yönetimi" },
              { title: "Sevkiyat İşlemi", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/mp-stokyonetimi/stok-transfer",
          name: "MpStokTransfer",
          component: () => import("@/views/mp-stokyonetimi/MpStokTransfer.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Stok Yönetimi" },
              { title: "Stok Transfer", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/finans/fatura_islemleri",
          name: "FaturaIslemleri",
          component: () => import("@/views/finans/FaturaIslemleri.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Finans" },
              { title: "Fatura İşlemleri", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/finans/fatura_detay",
          name: "FaturaDetay",
          component: () => import("@/views/finans/FaturaDetay.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Finans" },
              { title: "Fatura Detay", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/finans/cari_yonetimi",
          name: "CariYonetimi",
          component: () => import("@/views/finans/CariYonetimi.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Finans" },
              { title: "Cari Yönetimi", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/kullanicilar/kullanici_islemleri",
          name: "CariYonetimi",
          component: () => import("@/views/kullanicilar/KullaniciIslemleri.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Finans" },
              { title: "Cari Yönetimi", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/raporlar/trendyolfinans",
          name: "trendyolfinans",
          component: () => import("@/views/raporlar/TrendyolFinansman.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Trendyol" },
              { title: "Finansman", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/raporlar/marketplace-finans",
          name: "marketplace-finans",
          component: () => import("@/views/raporlar/MarketplaceFinansalVeriler.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Finansman", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/raporlar/ciceksepetifinans",
          name: "ciceksepetifinans",
          component: () => import("@/views/raporlar/CiceksepetiFinansman.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Çiçeksepeti" },
              { title: "Finansman", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/raporlar/morhipofinans",
          name: "morhipofinans",
          component: () => import("@/views/raporlar/MorhipoFinansman.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Morhipo" },
              { title: "Finansman", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/raporlar/gittigidiyorfinans",
          name: "morhipofinans",
          component: () => import("@/views/raporlar/GittigidiyorFinansman.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Gittigidiyor" },
              { title: "Finansman", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/raporlar/n11finans",
          name: "morhipofinans",
          component: () => import("@/views/raporlar/N11Finansman.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "N11" },
              { title: "Finansman", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/raporlar/hepsiburadafinans",
          name: "hepsiburadafinans",
          component: () => import("@/views/raporlar/HepsiburadaFinansman.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },
          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Hepsiburada" },
              { title: "Finansman", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },

        {
          path: "/raporlar/stoksatisrapor",
          name: "Satış",
          component: () => import("@/views/raporlar/StokSatisRaporu.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Rapor" },
              { title: "Stok Satış Raporu", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/raporlar/diaStokKartRaporu",
          name: "diaStokkart",
          component: () => import("@/views/raporlar/DiaStokKartRaporu.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Rapor" },
              { title: "Dia Stok Kart Raporu", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/raporlar/sevkbekleyen",
          name: "Satış",
          component: () => import("@/views/raporlar/SevkBekleyen.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Rapor" },
              { title: "Sevk Bekleyen Stok Raporu", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/raporlar/kargoRapor",
          name: "Satış",
          component: () => import("@/views/raporlar/kargoRapor.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Rapor" },
              { title: "Kargo Raporu", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/raporlar/siparisRaporu",
          name: "Satış",
          component: () => import("@/views/raporlar/SiparisRaporu.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Rapor" },
              { title: "Sipariş Raporu", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },

        {
          path: "/raporlar/kazancRaporu", //Karlılık Raporu
          name: "Satış",
          component: () => import("@/views/raporlar/GunlukKazancRaporu.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Rapor" },
              { title: "Kazanç Raporu", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        },
        {
          path: "/pazaryeri/stokKoduOlmayan",
          name: "Satış",
          component: () => import("@/views/pazaryeri/stokKoduOlmayan.vue"),
          beforeEnter(to, from, next) {
            if (Store.getters.isAutState) {
              next();
            } else {
              next("login");
            }
          },

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Pazaryeri" },
              { title: "Stok Kodu Eşleşmeyen Ürünler", active: true }
            ],
            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: "editor"
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: "/login",
          name: "page-login",
          component: () => import("@/views/pages/Login.vue")
        },
        {
          path: "/pages/error-404",
          name: "page-error-404",
          component: () => import("@/views/pages/Error404.vue")
        },
        {
          path: "/muhasebe-kategorileri",
          name: "muhasebe-kategorileri",
          component: () => import("@/views/pages/MuhasebeKategorileri.vue")
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/pages/error-404"
    }
  ]
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
